import React, { useEffect } from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from '@components'
import { useAdminMappingTable } from 'Pages/Admin/AdminMapping/Table/@hooks'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import {
	acrissColumn,
	actionsColumn,
	airConditionColumn,
	carModelColumn,
	categoriesColumn,
	countriesColumn,
	doorsColumn,
	officesColumn,
	ownerColumn,
	providersColumn,
	seatsColumn,
	sitesColumn,
	transmissionColumn,
} from 'Pages/Admin/AdminMapping/Table/columns'
import AdminMappingToolbarSelect from 'Pages/Admin/AdminMapping/Table/CustomToolbarSelect'


export default function AdminMappingTable({ path }) {
	const { getTableData, isTableLoading, tableData } = useAdminMappingTable(path)

	useEffect(() => {
		getTableData()
	}, [])


	if (isTableLoading) return <AppResultsSkeleton rows={13} columns={6}/>

	return <AppCrudTable
		title={<AppCardTitle icon="shuffle" title={path === MAPPING_TYPE.ACRISS ? "Custom ACRISS Mapping List" : "Custom Categories Mapping List"}/>}
		options={{
			tableBodyHeight: tableData.length > 10 ? '450' : '450px',
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <AdminMappingToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
				path={path}
			/>
		}}
		columns={[
			officesColumn(),
			...countriesColumn(),
			...sitesColumn(),
			path === MAPPING_TYPE.ACRISS ? acrissColumn() : categoriesColumn(),
			providersColumn(),
			carModelColumn(),
			doorsColumn(),
			seatsColumn(),
			transmissionColumn(),
			airConditionColumn(),
			ownerColumn(),
			actionsColumn(path)
		]}
		data={tableData}
	/>

}